import { PortfolioRoutesAvailability } from './routesConfig';

type PortfolioRoutesAvailabilityParams = {
    readonly isCustomerAvailable: boolean;
    readonly currentCustomerHasPortfolio: boolean;
    readonly isCurrentUserInternal: boolean;
    /** See useNextPreview: opted into with ?next=true, remembered for the session. */
    readonly isNextPreviewEnabled: boolean;
};

export const getPortfolioRoutesAvailabilityForCustomer = ({
    isCustomerAvailable,
    currentCustomerHasPortfolio,
    isCurrentUserInternal,
    isNextPreviewEnabled,
}: PortfolioRoutesAvailabilityParams): PortfolioRoutesAvailability => {
    const hasPortfolioDataAccess = isCustomerAvailable && currentCustomerHasPortfolio;
    // Three gates, all required. Data access and internal are permissions; the preview
    // switch only decides whether an internal user is shown the pages at all, so an
    // internal user's dashboard stays the customer-facing one until they ask for it.
    const canSeeNextPages = hasPortfolioDataAccess && isCurrentUserInternal && isNextPreviewEnabled;

    return {
        portfolioSummary: hasPortfolioDataAccess,
        portfolioSiteExplorer: hasPortfolioDataAccess,
        speciesRiskIndicators: hasPortfolioDataAccess,
        // Gating the sidebar alone would leave the pages' "not shown to customers"
        // banner untrue for anyone who typed the URL, so the routes close too.
        nextSpeciesRiskIndicators: canSeeNextPages,
        nextPortfolioSiteExplorer: canSeeNextPages,
        nextPortfolioSummary: canSeeNextPages,
        globalNatureRiskSiteList: isCustomerAvailable,
        globalNatureRiskOverview: isCustomerAvailable,
        globalNatureRiskStateOfNature: isCustomerAvailable,
        globalNatureRiskImpactsAndDependencies: isCustomerAvailable,
        portfolioFiles: hasPortfolioDataAccess,
    };
};

type PortfolioSidebarGroupVisibilityParams = {
    readonly portfolioRoutesAvailability: PortfolioRoutesAvailability;
};

export const shouldShowGlobalNatureRiskGroup = ({ portfolioRoutesAvailability }: PortfolioSidebarGroupVisibilityParams): boolean => {
    return portfolioRoutesAvailability.globalNatureRiskSiteList;
};

export const shouldShowGlobalNaturePerformanceGroup = ({ portfolioRoutesAvailability }: PortfolioSidebarGroupVisibilityParams): boolean => {
    return (
        portfolioRoutesAvailability.portfolioSummary ||
        portfolioRoutesAvailability.portfolioSiteExplorer ||
        portfolioRoutesAvailability.speciesRiskIndicators ||
        portfolioRoutesAvailability.portfolioFiles
    );
};
